// Angular
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg'
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker'
//import { MaterialModule } from "../../material.module"
//import { MatBadgeModule } from '@angular/material/badge'
// Perfect Scrollbar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar'
import { NgxSummernoteModule } from 'ngx-summernote'
import { BaseAtylModule } from '../../base/base.module'
// Core module
import { CoreModule } from '../../core/core.module'
import { DragDropDirective } from '../../motor-form-atyl/atyl-directive-components/drag-drop.directive'
import { TableAtylDisplayModule } from '../../motor-form-atyl/form-atyl-components/form-table-atyl-display/table-atyl-display.module'
import { MotorAtylModule } from '../../motor-form-atyl/motor-form-atyl'
import { PipesModule } from '../../pipes/pipes.module'
import { CreateConsultationDialogComponent } from './content/actions/create-consultation-dialog/create-consultation-dialog.component'
import { FoyerActionsDialog } from './content/actions/foyer-actions-dialog/foyer-actions-dialog.component'
import { SuiviActionsDialog } from './content/actions/suivi-actions-dialog/suivi-actions-dialog.component'
import { VisiteActionsDialog } from './content/actions/visite-actions-dialog/visite-actions-dialog.component'
import { InstructionActionsDialog } from './content/actions/instruction-actions-dialog/instruction-actions-dialog.component';
import { InstructionHistoriqueDialog } from './content/actions/instruction-historique-dialog/instruction-historique-dialog.component';
import { ModifUserDialog } from './content/actions/modif-user-dialog/modif-user-dialog.component';
import { MapDialog } from './content/map/dialog/map-dialog.component';

import { DossierRdvAccompagnantsComponent } from './content/dossier/dossier-rdv-accompagnants/dossier-rdv-accompagnants.component'
import { DossierRdvInstructionsComponent } from './content/dossier/dossier-rdv-instructions/dossier-rdv-instructions.component'
import { DossierRdvFormulairesComponent } from './content/dossier/dossier-rdv-formulaires/dossier-rdv-formulaires.component'
import { DossierRdvCourrierComponent } from './content/dossier/dossier-rdv-courrier/dossier-rdv-courrier.component'
import { DossierRdvDocumentComponent } from './content/dossier/dossier-rdv-document/dossier-rdv-document.component'

import { RechercheResultComponent } from './content/dossier/recherche-result/recherche-result.component'
import { RechercheTableComponent } from './content/dossier/recherche-result/recherche-table/recherche-table.component'
import { AddressCardComponent } from './content/general/address-card/address-card.component'
import { DossierPeronneComponent } from './content/dossier/dossier-personne/dossier-personne.component'
import { DossierMesVaccinsComponent } from './content/dossier/dossier-mecvaccins/dossier-mesvaccins.component'
import { DossierStatistiqueComponent } from './content/dossier/dossier-statistique/dossier-statistique.component'
import { DossierFoyerComponent } from './content/dossier/dossier-foyer/dossier-foyer.component'
import { DossierAdressesRelationsComponent } from './content/dossier/dossier-adresses-relations/dossier-adresses-relations.component'

import { DossierPageSyntheseComponent } from "../pages/recherche/dossier-page-tabs/dossier-page-synthese/dossier-page-synthese.component";
import { DossierPageCourbeComponent } from "../pages/recherche/dossier-page-tabs/dossier-page-courbe/dossier-page-courbe.component"
import { CourbeComponent } from '../pages/recherche/dossier-page-tabs/dossier-page-courbe/courbe/courbe.component'
import { DossierPageCourrierComponent } from '../pages/recherche/dossier-page-tabs/dossier-page-courrier/dossier-page-courrier.component'

import { NoteComponent } from './content/note/note.component'
import { NoteDialogComponent } from './content/note/dialog/note-dialog.component'

import { IaComponent } from './content/ia/ia.component'
import { IaDialogComponent } from './content/ia/dialog/ia-dialog.component'

import { MessageComponent } from './content/message/message.component'
import { MessageDialogComponent } from './content/message/dialog/message-dialog.component'



import { MapComponent } from './content/map/map.component'

// Errpr
import { ErrorComponent } from './content/general/error/error.component'
import { UserListComponent } from './content/general/user/user.component'
import { UserSearchListComponent } from './content/general/user-search/user-search.component'
import { FormulaireLockComponent } from './content/general/lock/lock.component'
import { SearchComponent } from './content/general/search/search.component'
// General
import { NoticeComponent } from './content/general/notice/notice.component'
import { PortletModule } from './content/general/portlet/portlet.module'
import { DocumentListing } from './content/listing/document-listing/document-listing.component'
import { FormulaireListing } from './content/listing/formulaire-listing/formulaire-listing.component'
import { FormulaireSuiviListing } from './content/listing/formulaire-suivi-listing/formulaire-suivi-listing.component'
import { SuiviListing } from './content/listing/suivi-listing/suivi-listing.component'
import { VisiteFormulairesListing } from './content/listing/visite-formulaires-listing/visite-formulaires-listing.component'
import { VisiteListing } from './content/listing/visite-listing/visite-listing.component'
import { InstructionListing } from './content/listing/instruction-listing/instruction-listing.component'

import { DashboardTabNotificationComponent } from './content/dashboard/dashboard-tab-notification/dashboard-tab-notification.component'
import { DashboardTabEnCoursComponent } from './content/dashboard/dashboard-tab-encours/dashboard-tab-encours.component'
import { DashboardTabZoneComponent } from './content/dashboard/dashboard-tab-zone/dashboard-tab-zone.component'

import { VidalDialogComponent } from './content/actions/vidal-action-dialog/vidal.component'

import {InstructionComponent }  from './content/instruction/instruction.component'


import { PanierAddComponent } from './content/panier/add/panier-add.component'
import { PanierListComponent } from './content/panier/list/panier-list.component'
import { PanierInstructionComponent } from './layout/dialogs/panier-instruction-dialog/panier-instruction.component'
import { ConsultationDialogComponent } from './layout/dialogs/consultation-dialog/consultation-dialog.component'
import { ConsultationMoveComponent } from './layout/dialogs/consultation-move-dialog/consultation-move.component'
import { VisiteDialogComponent } from './layout/dialogs/visite-dialog/visite-dialog.component'
import { PeriodicalCreationComponent } from './layout/dialogs/periodical-creation-dialog/periodical-creation.component'
import { NumericDirective } from "./layout/dialogs/periodical-creation-dialog/numeric.dictective"
import { MaxValidatorDirective,MinValidatorDirective } from "./layout/dialogs/periodical-creation-dialog/minmax.dictective"

import { FormDialogComponent } from './content/nomade/dialogs/form-dialog/form-dialog.component'
import { DocumentDialogComponent } from './content/nomade/dialogs/document-dialog/document-nomade-dialog.component'
import { TemplateRendererComponent } from './content/nomade/dialogs/template-renderer/template-renderer.component'
import { NomadeConsultationComponent } from './content/nomade/nomade-consutation/nomade-consulltation.component'
import { NomadeDeactivatorDialogComponent } from './content/nomade/nomade-deactivator/nomade-deactivator-dialog/nomade-deactivator-dialog.component'
import { NomadeDeactivatorComponent } from './content/nomade/nomade-deactivator/nomade-deactivator.component'
import { NomadeDossierComponent } from './content/nomade/nomade-dossier/nomade-dossier.component'
import { NomadeFormComponent } from './content/nomade/nomade-form/nomade-form.component'
import { NomadeHomeComponent } from './content/nomade/nomade-home/nomade-home.component'
import { NomadeQuickMenuComponent} from './content/nomade/nomade-quickmenu/quickmenu.component'
import { NomadeDossierDocumentsComponent } from './content/nomade/nomade-dossier/nomade-dossier-tabs/nomade-dossier-document/nomade-dossier-documents.component'
import { NomadeDossierFormulairesComponent } from './content/nomade/nomade-dossier/nomade-dossier-tabs/nomade-dossier-formulaire/nomade-dossier-formulaires.component'

import { SecurityQuestionComponent } from './content/nomade/security-question/security-question.component'
import { DesignModule } from './design/design.module'


import { RelationInformationComponent } from './layout/relation-information/relation-information.component'

import { ContextMenuComponent } from './layout/context-menu/context-menu.component';

import { DossierActionComponent } from './content/dossier/dossier-action/dossier-action.component';


import { GroupeComponent } from './content/groupe/groupe.component'
import { GroupeDialogComponent } from './content/groupe/dialog/groupe-dialog.component'
import { GroupeListComponent } from './content/groupe/list/list.component'

// CRUD Partials
// Layout partials
import {
	QuickPanelComponent,
	ScrollTopComponent,
	SearchResultComponent,
	SplashScreenComponent,
	Subheader3Component,
	QuickMenuComponent
} from './layout'
import { ConfirmComponent } from './layout/dialogs/confirm-dialog/confirm.component'
import { DossierAlerteDialogComponent } from './layout/dialogs/dossier-alerte-dialog/dossier-alerte-dialog.component'
import { EtapeinstructionComponent } from './layout/dialogs/etapeinstruction-dialog/etapeinstruction.component'
import { InstructionPersonneComponent } from './layout/dialogs/instruction-personne-dialog/instruction-personne.component'

import { FormulaireDossierDialogComponent } from './layout/dialogs/formulaire-dossier-dialog/formulaire-dossier-dialog.component'
import { SaveFiltersDialog } from './layout/dialogs/save-filters-dialog/save-filters-dialog.component'
import { UploadFileDialogComponent } from './layout/dialogs/upload-file-dialog/upload-file-dialog.component'
import { LoadDialogComponent } from './layout/dialogs/load-dialog/load.component'
import { MesVaccinsAssociateComponent } from './layout/dialogs/mesvaccins-associate-dialog/mesvaccins-associate.component'


import { ChoiceCourrierComponent } from './layout/dialogs/choice-courrier-dialog/choice-courrier.component'
import { CourrierDialog } from './layout/dialogs/courrier-dialog/courrier-dialog.component'
import { MessageInfoComponent } from './layout/dialogs/message-info-dialog/message-info.component'

import { DossierAlerteComponent } from './layout/dossier-alerte/dossier-alerte.component'
import { AtylMinimizeGroupComponent } from './layout/minimize/group/group.component'
import { AtylMinimizeTabComponent } from './layout/minimize/tab/tab.component'
import { TabGroupComponent } from './layout/tab-group/tab-group.component'
import { TabComponent } from './layout/tab-group/tab/tab.component'
import { TiersAdresseComponent } from './layout/tiers-adresse/tiers-adresse.component'
import { TimepickerComponent } from './layout/timepicker/timepicker.component'
import { UserProfileComponent } from './layout/topbar/user-profile/user-profile.component'
import { UserProfileModifComponent } from './layout/topbar/user-profile/user-profile-info/user-profile-info.component'
import { WeekComponent } from './layout/week/week.component'
import { RechercheTiersDialogComponent } from './layout/dialogs/recherche-tiers-dialog/recherche-tiers-dialog.component'
import { NouveauFormComponent } from './content/nouveau/nouveau-form/nouveau-form.component';


import { PrintDialog } from './layout/dialogs/print-dialog/print-dialog.component'


import { CalendarComponent } from './content/consultation/calendar/calendar.component'
import { DayComponent } from './content/consultation/calendar/day/day.component'
import { ConsultationSingleComponent } from './content/consultation/consultation-single/consultation-single.component'
import { CustomToolTipComponent } from './content/consultation/consultation-single/tooltip/custom-tool-tip.component';
import { ToolTipRendererDirective } from './content/consultation/consultation-single/tooltip/custom-tool-tip.directive';
import { ConsultationSliderComponent } from './content/consultation/consultation-slider/consultation-slider.component';
import { DocumentListingInForm } from './content/listing/document-listing-in-formulaire/document-listing-in-formulaire.component'
import { FormulaireInformationComponent } from './layout/formulaire-information/formulaire-information.component';

import { VisiteListDialog} from "./content/actions/visite-list-dialog/visite-list-dialog.component";
import { VisiteListComponent } from "../partials/content/consultation/visites/visite-list/visite-list.component";
import { VisiteSingleComponent } from "../partials/content/consultation/visites/visite-single/visite-single.component";

import { CalendarMonthlyComponent } from "../partials/content/consultation/calendar-monthly/calendar.component";

import { ActionCollectiveDossierTabInstructionObjectComponent } from '../pages/actioncollective/dossier/tabs/instruction/une-instruction-object/une-instruction-object.component'
import { DeclencheToolTipComponent } from '../pages/recherche/dossier-page-tabs/dossier-page-formulaire/tooltip/declenche-tool-tip.component';
import { ToolTipDeclencheRendererDirective } from '../pages/recherche/dossier-page-tabs/dossier-page-formulaire/tooltip/declenche-tool-tip.directive';
import { LocationInputComponent } from './content/general/location-input/location-input.component'
import { ConsultationStateChangeDialog } from './layout/dialogs/consultation-statechange-dialog/consultation-statechange.component'
import { ConsultationShiftDialog } from './layout/dialogs/consultation-shift/consultation-shift.component'
@NgModule({
	declarations: [
		DossierAlerteComponent,
		DossierAlerteDialogComponent,
		MesVaccinsAssociateComponent,
		ScrollTopComponent,
		NoticeComponent,
		ConfirmComponent,
		// topbar components
		QuickPanelComponent,
        DocumentListingInForm,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		Subheader3Component,
		QuickMenuComponent,
		RechercheResultComponent,
		RechercheTableComponent,
		ErrorComponent,
		UserListComponent,
		FormulaireLockComponent,
		UserSearchListComponent,
		DragDropDirective,
		UserProfileComponent,
        UserProfileModifComponent,
		UploadFileDialogComponent,
		LoadDialogComponent,
		ChoiceCourrierComponent,
		CourrierDialog,
        MessageInfoComponent,
		FoyerActionsDialog,
		SuiviActionsDialog,
		InstructionActionsDialog,
		InstructionHistoriqueDialog,
        ModifUserDialog,
		VidalDialogComponent,	
		PanierAddComponent,
		PanierListComponent,
		SuiviListing,
		VisiteListing,
		InstructionListing,
		DashboardTabNotificationComponent,
		DashboardTabEnCoursComponent,
		DashboardTabZoneComponent,
		CreateConsultationDialogComponent,
		FormulaireSuiviListing,
		WeekComponent,
		VisiteActionsDialog,
		MapDialog,
		TimepickerComponent,
		AddressCardComponent,
		VisiteFormulairesListing,
		TiersAdresseComponent,
		FormulaireListing,
		TabGroupComponent,
		TabComponent,
		DossierRdvFormulairesComponent,
		DossierRdvCourrierComponent,
		DossierRdvDocumentComponent,
		DossierPeronneComponent,
		DossierMesVaccinsComponent,
		DossierStatistiqueComponent,
		DossierFoyerComponent,
        DossierAdressesRelationsComponent,
		DossierRdvAccompagnantsComponent,
		DossierRdvInstructionsComponent,
		FormulaireDossierDialogComponent,
		EtapeinstructionComponent,
		InstructionPersonneComponent,
		PanierInstructionComponent,
		ConsultationDialogComponent,
		ConsultationMoveComponent,
		VisiteDialogComponent,
		PeriodicalCreationComponent,
		NumericDirective,
		MaxValidatorDirective,
		MinValidatorDirective,
		SaveFiltersDialog,
		DocumentListing,
		AtylMinimizeGroupComponent,
		AtylMinimizeTabComponent,
		SecurityQuestionComponent,
		NomadeHomeComponent,
		NomadeDossierComponent,
		NomadeQuickMenuComponent,
        NomadeDossierDocumentsComponent,
        NomadeDossierFormulairesComponent,
		FormDialogComponent,
        DocumentDialogComponent,
		TemplateRendererComponent,
		NomadeFormComponent,
		NomadeDeactivatorComponent,
		NomadeDeactivatorDialogComponent,
		NomadeConsultationComponent,
		RechercheTiersDialogComponent,
		PrintDialog,
		NouveauFormComponent,
		CalendarComponent,
		DayComponent,
		ConsultationSingleComponent,
		CustomToolTipComponent,
		ToolTipRendererDirective,
		ConsultationSliderComponent,
		InstructionComponent,
		NoteComponent,
		NoteDialogComponent,		
		IaComponent,
		IaDialogComponent,
		MessageComponent,
		MessageDialogComponent,
		MapComponent,
		FormulaireInformationComponent,
        DossierPageSyntheseComponent,
		
		DossierPageCourbeComponent,
		CourbeComponent,
		DossierPageCourrierComponent,
		
        VisiteListDialog,
        VisiteListComponent,
        VisiteSingleComponent,

		DeclencheToolTipComponent,
		ToolTipDeclencheRendererDirective,
		ActionCollectiveDossierTabInstructionObjectComponent,
		CalendarMonthlyComponent,
		LocationInputComponent,
		ConsultationStateChangeDialog,
		ConsultationShiftDialog,
		RelationInformationComponent,
		ContextMenuComponent,
		DossierActionComponent,
		GroupeComponent,
		GroupeDialogComponent,
		GroupeListComponent	,
		SearchComponent
	],
	exports: [
		ConfirmComponent,
		PortletModule,

		ScrollTopComponent,
		NoticeComponent,
		// topbar components
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
        DocumentListing,
        DocumentListingInForm,
		Subheader3Component,
		QuickMenuComponent,		
		ErrorComponent,
		UserListComponent,
		FormulaireLockComponent,
		UserSearchListComponent,
		UserProfileComponent,
        UserProfileModifComponent,
		FoyerActionsDialog,
		SuiviActionsDialog,
		InstructionActionsDialog,
		InstructionHistoriqueDialog,
        ModifUserDialog,
		VidalDialogComponent,
		PanierAddComponent,
		PanierListComponent,
		CreateConsultationDialogComponent,
		WeekComponent,
		TimepickerComponent,
		AddressCardComponent,
		TiersAdresseComponent,
		FormulaireListing,
		DashboardTabNotificationComponent,
		DashboardTabEnCoursComponent,
		DashboardTabZoneComponent,
		DocumentListing,
		TabGroupComponent,
		TabComponent,
		DossierRdvFormulairesComponent,
		DossierRdvCourrierComponent,
		DossierRdvDocumentComponent,
		DossierPeronneComponent,
        DossierAdressesRelationsComponent,
		DossierMesVaccinsComponent,
		DossierStatistiqueComponent,
		DossierFoyerComponent,
		DossierRdvAccompagnantsComponent,
		DossierRdvInstructionsComponent,
		DossierAlerteComponent,
		FormulaireDossierDialogComponent,
		EtapeinstructionComponent,
		InstructionPersonneComponent,
		PanierInstructionComponent,
		ConsultationDialogComponent,
		ConsultationMoveComponent,
		PeriodicalCreationComponent,
		VisiteDialogComponent,
		AtylMinimizeGroupComponent,
		AtylMinimizeTabComponent,
		RechercheResultComponent,
		RechercheTableComponent,
		SecurityQuestionComponent,
		NomadeHomeComponent,
		NomadeDossierComponent,
		NomadeQuickMenuComponent,
        NomadeDossierDocumentsComponent,
        NomadeDossierFormulairesComponent,
		FormDialogComponent,
        DocumentDialogComponent,
		TemplateRendererComponent,
		NomadeFormComponent,
		NomadeDeactivatorComponent,
		NomadeConsultationComponent,
		NouveauFormComponent,
		RechercheTiersDialogComponent,
		PrintDialog,
		ConsultationSliderComponent,
		InstructionComponent,
		NoteComponent,
		IaComponent,
		MessageComponent,
		MapComponent,
		FormulaireInformationComponent,
        DossierPageSyntheseComponent,

		DossierPageCourbeComponent,
		CourbeComponent,
		DossierPageCourrierComponent,
		
        VisiteListDialog,
        VisiteListComponent,
        VisiteSingleComponent,

		DeclencheToolTipComponent,
		ToolTipDeclencheRendererDirective,
		CalendarMonthlyComponent,
		LocationInputComponent,
		ConsultationStateChangeDialog,
		ConsultationShiftDialog,
		RelationInformationComponent,
		ContextMenuComponent,
		DossierActionComponent,
		GroupeComponent,
		GroupeListComponent,
		SearchComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		PerfectScrollbarModule,
		InlineSVGModule,
		CoreModule,
		PortletModule,
		DesignModule,
		NgxSummernoteModule,
		PipesModule,
		BaseAtylModule,
		TableAtylDisplayModule,
		NgxMaterialTimepickerModule.setOpts('fr-FR','french'),
		MotorAtylModule,
		
		//MaterialModule,
		//MatBadgeModule
	],
	providers: [],
	entryComponents: [
		UploadFileDialogComponent,
		LoadDialogComponent,
		ChoiceCourrierComponent,
		CourrierDialog,
        MessageInfoComponent,
		FoyerActionsDialog,
		SuiviActionsDialog,
		InstructionActionsDialog,
		InstructionHistoriqueDialog,
        ModifUserDialog,
		VidalDialogComponent,
		SuiviListing,
		VisiteListing,
		InstructionListing,
		DashboardTabNotificationComponent,
		FormulaireSuiviListing,
		VisiteFormulairesListing,
		CreateConsultationDialogComponent,
		VisiteActionsDialog,
		MapDialog,
		FormulaireListing,
		DossierAlerteDialogComponent,
		MesVaccinsAssociateComponent,
		ConfirmComponent,
		FormulaireDossierDialogComponent,
		EtapeinstructionComponent,
		InstructionPersonneComponent,
		PanierInstructionComponent,
		ConsultationDialogComponent,
		ConsultationMoveComponent,
		PeriodicalCreationComponent,
		VisiteDialogComponent,
		SaveFiltersDialog,
		DocumentListing,
		FormDialogComponent,
        DocumentDialogComponent,
		NomadeDeactivatorDialogComponent,
		RechercheTiersDialogComponent,
		CustomToolTipComponent,
		PrintDialog,
		ConsultationSliderComponent,
		InstructionComponent,
		NoteDialogComponent,
		IaDialogComponent,		
		MessageDialogComponent,
		VisiteListDialog,
        VisiteListComponent,
        VisiteSingleComponent,
		
		ActionCollectiveDossierTabInstructionObjectComponent,
		DeclencheToolTipComponent,
		CalendarMonthlyComponent,
		ConsultationStateChangeDialog,
		ConsultationShiftDialog,
		TiersAdresseComponent,
		ContextMenuComponent,
		GroupeDialogComponent,

	],
})
export class PartialsModule { }
